import { type FormItemProps } from 'antd/es/form';
import { FieldArray } from 'formik';
import { get } from 'lodash/fp';
import { type TranslatedStringDataFragment } from '../../../../api/fragments/TranslatedStringData';
import FormItem from '../../../../components/fields/FormItem';
import { type WebpageFormikValue } from '../shared';
import DescriptionTable from './DescriptionTable';

export interface ImageDescriptionInputArrayProps {
    name: string;
    label?: string;
    labelForAdd?: string;
    itemProps?: Omit<FormItemProps, 'label' | 'meta' | 'required' | 'children'>;
    limit?: number;
    disabled?: boolean;
}

const TextCarouselDescription = ({
    name,
    label,
    labelForAdd,
    itemProps,
    limit,
    disabled = false,
    ...props
}: ImageDescriptionInputArrayProps) => (
    <FormItem {...itemProps} label={label} name={name}>
        <FieldArray
            name={name}
            render={arrayHelpers => {
                const webpage = arrayHelpers.form.values as WebpageFormikValue;
                const webpageColumn = get(name, webpage) as TranslatedStringDataFragment[];

                return (
                    <DescriptionTable
                        descriptionsTable={webpageColumn}
                        disabled={disabled}
                        name={name}
                        remove={arrayHelpers.remove}
                    />
                );
            }}
        />
    </FormItem>
);

export default TextCarouselDescription;
